import AppBar from './AppBar';
import Content from './Content';
import PageWithStaticHeader from './PageWithStaticHeader';

export default Object.assign(PageWithStaticHeader, { AppBar, Content });
